
import { Component, Vue, Prop } from "vue-property-decorator";
import ScrollTopButton from "@/components/core/ScrollTopButton.vue";
@Component({
  components: {
    ScrollTopButton,
  },
})
export default class Footer extends Vue {
  @Prop({ required: false, default: false }) private includeFab: boolean;
}
